import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { PrimaryButton } from '@bibliocommons/base-buttons';

export default function EditHoldDatesButton({ handleClick, isLoading, disabled }) {
  return (
    <PrimaryButton
      isLoading={isLoading}
      disabled={disabled}
      className="cp-edit-hold-button"
      handleClick={handleClick}>
      <FormattedMessage id="holds_batch_action_edit_dates" />
    </PrimaryButton>
  );
}

EditHoldDatesButton.propTypes = {
  handleClick: PropTypes.func,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/EditHoldDatesButton/EditHoldDatesButton.jsx